const NESA_PRIVACY_URL =
  "https://www.nsw.gov.au/education-and-training/nesa/about/privacy";

/**
 * Privacy statement for the Teaching Gems Map submission form, transcribed
 * from "Privacy Statement_Teaching Gems Map 2026.docx".
 *
 * Uses the NSW Design System's details-based accordion, which needs no
 * JavaScript: open/closed is the native <details> `open` attribute, and
 * keyboard and screen-reader support come with the element. Collapsed by
 * default so the statement is available without dominating the page.
 * https://designsystem.nsw.gov.au/components/accordion/index.html
 *
 * Renders the bare <details> item; the `.nsw-accordion` wrapper lives in
 * IntroContent so this and FindYourSchool read as one accordion group.
 */
const PrivacyStatement = () => (
  <details className="nsw-accordion__item" id="privacy-statement">
    <summary className="nsw-accordion__title">
      Teaching Gems Map Privacy Statement
    </summary>
    <div className="nsw-accordion__content-wrap" id="privacy-statement-panel">
      <div className="nsw-accordion__content">
        <p>
          NESA collects the personal information you provide when completing
          the Teaching Gems Map submission form via Microsoft Forms, managed
          by NESA. NESA uses this platform and the information you provide to
          allow you to add a gem to the Teaching Gems Map and a custom message
          to a teacher in your school community.
        </p>
        <p>
          Your message and other information you provide will be stored
          securely on servers located within NSW and will only be accessible
          to authorised NESA staff members who will review your custom message
          before publishing it. Your message and other information you provide
          will be retained for up to 180 days, while the Map remains visible
          to the public but inactive for submissions or use, then be permanently
          deleted thereafter.
        </p>
        <p>
          Please note the information you provide may be used by other NSW
          Government agencies within the NSW education portfolio to promote the
          Teaching Gems Map for the duration of the campaign. The information
          accessed by these NSW Government agencies is aggregated data which
          does not identify any individual. Personal information collected
          will not be used or disclosed for any purpose other than the purposes
          stated above unless such use or disclosure is required or permitted
          by law. For more information, please visit the{" "}
          <a href={NESA_PRIVACY_URL}>NESA website</a>.
        </p>
        <p>
          Please proceed to the submission form if you have read, understood
          and agreed with the Privacy Statement and the terms and conditions of
          this event.
        </p>
      </div>
    </div>
  </details>
);

export default PrivacyStatement;
